import type { NSchedule } from '@app/types';

export const checkWorkingHours = (
  timeStr = '',
  workingHours: NSchedule.ModelWorkSchedule[] = []
) => {
  const currentTime = `${timeStr}:00`;

  for (let i = 0; i < workingHours.length; i++) {
    const startTime = workingHours[i].TimeS.slice(-8);
    const endTime = workingHours[i].TimeE.slice(-8);

    if (currentTime >= startTime && currentTime <= endTime) {
      return true;
    }
  }

  return false;
};
